<app-navbar />

<main id="main-content">
  <section class="page-hero">
    <div class="container">
      <app-breadcrumb [trail]="[{ label: 'Book a call' }]" />
      <span class="eyebrow">Free consultation</span>
      <h1>Schedule a call with our team</h1>
      <p>
        Pick a time that works for you. We will walk you through the platform, answer your questions
        and help you decide if VerifyDeceased is the right fit. No obligation, no pressure.
      </p>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="book-layout">
        <aside class="book-info">
          <h2>What to expect on the call</h2>
          <ul class="check-list">
            @for (item of expectations; track item) {
              <li>{{ item }}</li>
            }
          </ul>

          <div class="book-contact">
            <p class="book-contact-title">Prefer to talk now?</p>
            <a class="book-contact-row" [href]="site.phoneHref">
              <span class="book-contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" />
                </svg>
              </span>
              <span>
                <span class="book-contact-label">Call us today</span>
                <span class="book-contact-value">{{ site.phone }}</span>
              </span>
            </a>
            <a class="book-contact-row" [href]="'mailto:' + site.email">
              <span class="book-contact-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="m22 7-10 6L2 7" />
                </svg>
              </span>
              <span>
                <span class="book-contact-label">Email us</span>
                <span class="book-contact-value">{{ site.email }}</span>
              </span>
            </a>
          </div>
        </aside>

        <div class="book-form-card">
          @if (submitted()) {
            <div class="book-success">
              <span class="book-success-icon" aria-hidden="true">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              <h2>Your request is in</h2>
              <p>
                Thanks {{ model.name || "there" }}. A member of our team will reach out shortly to
                confirm your session time. We look forward to speaking with you.
              </p>
              <a class="btn btn-outline" [routerLink]="[routes.home.url]">Back to home</a>
            </div>
          } @else {
            <h2>Request your session</h2>
            <p class="book-form-lead">Tell us a little about you and your preferred time.</p>

            <form (ngSubmit)="submit()" #bookForm="ngForm">
              <div class="form-row">
                <div class="form-group">
                  <label for="name">Full name</label>
                  <input id="name" name="name" class="form-control" [(ngModel)]="model.name" required
                    placeholder="Jane Doe" />
                </div>
                <div class="form-group">
                  <label for="email">Work email</label>
                  <input id="email" name="email" type="email" class="form-control"
                    [(ngModel)]="model.email" required placeholder="jane@company.com" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label for="company">Company</label>
                  <input id="company" name="company" class="form-control" [(ngModel)]="model.company"
                    placeholder="Company name" />
                </div>
                <div class="form-group">
                  <label for="phone">Phone</label>
                  <input id="phone" name="phone" class="form-control" [(ngModel)]="model.phone"
                    placeholder="(909) 315-5330" />
                </div>
              </div>

              <div class="form-group">
                <label for="slot">Preferred time</label>
                <select id="slot" name="slot" class="form-control" [(ngModel)]="model.slot">
                  <option value="" disabled>Select a window</option>
                  @for (slot of slots; track slot) {
                    <option [value]="slot">{{ slot }}</option>
                  }
                </select>
              </div>

              <div class="form-group">
                <label for="notes">What would you like to cover?</label>
                <textarea id="notes" name="notes" class="form-control" rows="3"
                  [(ngModel)]="model.notes" placeholder="Your use case, volumes or questions"></textarea>
              </div>

              <button type="submit" class="btn btn-primary btn-block btn-lg"
                [disabled]="bookForm.invalid">Request my session</button>
              <p class="form-note">We respect your time and your data. We will never share your details.</p>
            </form>
          }
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer />
